export function mapObject(o, mapFn) {
    return Object.keys(o).map((k) => {
        const key = k;
        const val = o[key];
        const ret = mapFn(val, key);
        return ret;
    });
}
//# sourceMappingURL=mapObject.js.map